
export default function FieldLocation({ location, onChange }) {
	return (
		<div className="relative">
			<input
				type="text"
				id="doctor-location"
				value={location ?? ""}
				onChange={onChange}
				className="w-full font-Vazir-400 rounded-xl border border-[#E2E8F0] px-4 pt-6 pb-3 text-[15px] text-midGray focus:outline-none focus:border-darkBlue/40 focus:ring-2 focus:ring-darkBlue/10"
			/>
			<label
				htmlFor="doctor-location"
				className="absolute right-4 -top-2.5 bg-white px-1 text-grayText font-Vazir-500 text-[13px]"
			>
				نشانی
			</label>
		</div>
	);
}
